import { render } from "./AthleteSummaryBar.vue?vue&type=template&id=3146f55c&scoped=true"
import script from "./AthleteSummaryBar.vue?vue&type=script&lang=js"
export * from "./AthleteSummaryBar.vue?vue&type=script&lang=js"

import "./AthleteSummaryBar.vue?vue&type=style&index=0&id=3146f55c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3146f55c"]])

export default __exports__